/**
 * The confirmation asked before an Apple / Google purchase — in the paywall
 * above "ATTIVA ORA" and in the Shop's subscription sheet.
 *
 * Word for word the backend's own sentence (PurchaseConsentCatalog), which is
 * what it records as proof; a test keeps the two equal. Store purchases ask for
 * this one only: the immediate-access/withdrawal confirmation stays out because
 * Apple and Google apply their own refund rules (client, 05/10/2026).
 */
export const TERMS_PRIVACY_CONSENT = "terms_privacy";

export const TERMS_PRIVACY_SEGMENTS = [
  { type: "text", value: "Ho letto e accetto i " },
  { type: "link", document: "terms", label: "Termini e Condizioni" },
  { type: "text", value: " e dichiaro di aver preso visione dell'" },
  { type: "link", document: "privacy", label: "Informativa Privacy" },
  { type: "text", value: "." },
];

export const CONSENT_REQUIRED_MESSAGE =
  "Per procedere devi accettare le condizioni indicate.";

/** The sentence as read, links reduced to their labels. */
export const consentPlainText = (segments) =>
  segments
    .map((segment) => (segment.type === "link" ? segment.label : segment.value))
    .join("");

/** Which in-app legal page each link opens (see pages/Legal). */
export const LEGAL_SLUG_BY_DOCUMENT = {
  terms: "terms",
  privacy: "privacy-policy",
};
